import React from 'react'

function ServerService(){
    return(
        <div className="sub_page_wrapper page_content">
            <h3>Server Infrastructure Implementation and Management</h3>

            <p>
            Server management form an integral part of our portfolio. We possess skills in configuration,
virtual and physical management including the installation of complex software and the distribution
of security updates, patches and release management.
            </p>

            <p>
            Our expertise extends to Data Centre (DC) infrastructure management, through the use of specialized
software and hardware to monitor and ensure adequate capacity is available to maintain
the DC critical system and connections.
            </p>

            <p>
            Our server room services include, facility scheduled and remedial maintenance, BAU support
and maintenance, systems monitoring and system hardware management and support. This
provides a stable data centre environment that is supported and managed within the stipulated
service levels.
            </p>

        </div>
    )
}

export default ServerService;